export default __webpack_public_path__ + "static/media/Machine.e44e4e06.png";